// extracted by mini-css-extract-plugin
module.exports = {"timer":"_1m1Bj3","circle":"_3zZL36"};